import { useMemo } from 'react'

import { debounce } from '../lib/util'
import {
  lookup as ensLookup,
  reverseLookup as ensReverseLookup,
  isENSDomain
} from '../lib/ens'

type ENSResolver = (value: string) => Promise<string>

type ENS = {
  lookup: ENSResolver
  reverseLookup: ENSResolver
  isENSDomain: typeof isENSDomain
}

const DEFAULT_OPTIONS = {
  delay: 750
}

export default function useENS({
  delay
} = DEFAULT_OPTIONS): ENS {
  return useMemo(() => {
    if (delay > 0) {
      return {
        lookup: debounce(ensLookup, delay),
        reverseLookup: debounce(ensReverseLookup, delay),
        isENSDomain
      }
    }

    return {
      lookup: ensLookup,
      reverseLookup: ensReverseLookup,
      isENSDomain
    }
  }, [delay])
}
